import React from "react"
import useToggler from "./useToggler"
import { Link } from "gatsby"

const Form = () => {
  const [isChecked, toggle] = useToggler(false)

  const buttonClass = isChecked ? "button primary" : "button primary unchecked"

  return (
    <>
      <h2 className="text-center mb-2">
        Une question, un projet de site web, envie de s'inscrire ?<br />
        Contactez-nous
      </h2>
      <form
        className="contact-form"
        id="contact-form"
        method="post"
        action="https://formspree.io/f/xnqovrza"
      >
        <label htmlFor="_replyto">
          Email
          <input
            type="email"
            id="_replyto"
            name="_replyto"
            placeholder="Votre email"
            required
          />
        </label>
        <label htmlFor="name">
          Prénom et nom
          <input
            type="text"
            name="name"
            id="name"
            placeholder="Vos nom et prénom"
            required
          />
        </label>
        <label htmlFor="message">
          Message
          <textarea
            name="message"
            id="message"
            placeholder="Votre message"
            required
          ></textarea>
        </label>
        <label htmlFor="toggler">
          <input
            type="checkbox"
            className="contact-form__acceptance"
            checked={isChecked}
            required
            name="toggler"
            id="toggler"
            onChange={toggle}
          />
          J'ai lu et accepte la{" "}
          <Link to="/politique-de-confidentialite">
            politique de confidentialité
          </Link>{" "}
          de ce site
        </label>
        <button className={buttonClass} type="submit">
          ENVOYER
        </button>
      </form>
    </>
  )
}

export default Form
